export async function apiFetch(url: string, options: any = {}) {
  const token = localStorage.getItem('authToken');
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include', // Always send cookies for SSO
  });

  // Handle 401 Unauthorized responses
  if (response.status === 401) {
    console.log('🚫 401 Unauthorized - clearing token');
    // Clear invalid token
    localStorage.removeItem('authToken');
  }

  return response;
} 